import React from "react";

const replacePlaceHolders = (text: string, data?: any): string => {
  if (!data) return text;
  return text.replace(/{([^}]+)}/g, (match, key) => data[key] || match);
};

const snackbarColors = (
  status: "success" | "error" | "info" | "warning"
): {
  backgroundColor: string;
  borderColor: string;
  btnColor: string;
} => {
  switch (status) {
    case "info":
      return {
        backgroundColor: "rgba(238, 244, 251, 1)",
        borderColor: "#C0D7F8",
        btnColor: "rgba(6, 33, 51, 0.8)",
      };
    case "warning":
      return {
        backgroundColor: "rgba(251, 248, 238, 1)",
        borderColor: "#F8E9C0",
        btnColor: "rgba(255, 212, 59, 0.9)",
      };
    default:
      return {
        backgroundColor: "rgba(238, 244, 251, 1)",
        borderColor: "#C0D7F8",
        btnColor: "rgba(6, 33, 51, 0.8)",
      };
  }
};

interface IDynamicIconModule {
  [key: string]: any;
}
const getDynamicIcon = (
  iconName: string,
  module: IDynamicIconModule,
  size = 24
): React.ReactNode | null => {
  try {
    const Icon = (module as { [key: string]: any })[iconName];
    return Icon ? React.createElement(Icon, { size }) : null;
  } catch (error) {
    return null;
  }
};

export { replacePlaceHolders, snackbarColors, getDynamicIcon };
